module.exports = __webpack_public_path__ + "img/deifrati.027b49bd.jpeg";